// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_08M","largestCol":"styles_largestCol__2t6fm","smallestCol":"styles_smallestCol__1ID4Q"};